// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-item-img[data-v-69076110]{width:40px;height:40px}.filter-item__dropdown[data-v-69076110]{max-width:300px}.disabled[data-v-69076110]{pointer-events:none;opacity:.5}", ""]);
// Exports
module.exports = exports;
